import React from 'react';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export const DealResultEmpty = () => (
  <div className="bg-cool-gray-80 rounded-20 p-1_5 d-flex flex-column align-items-center">
    <div className="empty-screen rounded-circle pos-r bg-white mx-auto mb-1">
      <img src={getStaticImageUrl(`/img/lease-deals/icon-diamond-question.svg`)} alt="" className="pos-a center-xy" />
    </div>
    <strong className="size-20 text-cool-gray-10 text-center">Find out what you’re really paying</strong>
    <div className="size-16 text-cool-gray-30 mt-0_25">Enter your lease details.</div>
  </div>
);
